<div class="mb-2 mt-3" *ngIf="notesCollection?.length > 0">
  <ng-container *cignaResponsive="let screen">
    <label class="acronym"
      ><b>{{ 'drugNameSearch.notes.section_title' | translate }}</b>
    </label>

    <div *ngIf="indicator === 'IFP'">
      <div *ngFor="let stateException of notesException">
        <div class="mb-2" [ngClass]="{ row: consumerId === 'chcp' }">
          <small [innerHTML]="stateException"></small>
        </div>
      </div>
    </div>
    <div
      [ngClass]="{ row: consumerId === 'chcp' }"
      *ngIf="['IFP', 'nonIFP'].includes(indicator)"
    >
      <small [innerHTML]="'drugNameSearch.notes.sub_info' | translate"></small>
    </div>
    <div *ngFor="let noteVal of notesCollection">
      <div class="padding">
        <div class="row pt-2 notes">
          <div
            class="notes-val"
            [ngClass]="{ 'col-1': screen.isLargerOrEqual('md') }"
          >
            <small class="pt-1 pl-1 pr-3"
              ><b>{{ noteVal }}</b></small
            >
          </div>
          <div
            *ngIf="
              !['SD', 'SDS'].includes(noteVal) &&
                !(isNYMessage && noteVal === 'DS');
              else nyMessage
            "
            [ngClass]="{ 'col-11': screen.isLargerOrEqual('md') }"
          >
            <small
              ><b>
                {{
                  'drugNameSearch.notes.' + noteVal + '.long_form' | translate
                }}:</b
              >
              <span
                [innerHTML]="
                  'drugNameSearch.notes.' + noteVal + '.description' | translate
                "
              >
              </span
            ></small>
          </div>
          <div
            *ngIf="noteVal === 'SDS'"
            [ngClass]="{ 'col-11': screen.isLargerOrEqual('md') }"
          >
            <small *ngIf="msdLimitValue === rsdLimitValue; else dayLimit">
              <b>
                {{
                  'drugNameSearch.notes.' + noteVal + '.long_form' | translate
                }}:</b
              >
              {{
                'drugNameSearch.notes.SDS.description_XX'
                  | translate : { msdLimit: msdLimitValue }
              }}"
            </small>
          </div>
          <div
            *ngIf="noteVal === 'SD'"
            [ngClass]="{ 'col-11': screen.isLargerOrEqual('md') }"
          >
            <small
              *ngIf="
                otherInfo.mailSpecialtyDaySupply ===
                  otherInfo.retailSpecialtyDaySupply;
                else daySupply
              "
            >
              <b>
                {{
                  'drugNameSearch.notes.' + noteVal + '.long_form' | translate
                }}:</b
              >
              {{
                'drugNameSearch.notes.SD.description_XX'
                  | translate : { msdSupply: otherInfo.mailSpecialtyDaySupply }
              }}"
            </small>
          </div>
          <ng-template #dayLimit>
            <small>
              <b>
                {{
                  'drugNameSearch.notes.' + noteVal + '.long_form' | translate
                }}:</b
              >
              {{
                'drugNameSearch.notes.SDS.description_XY'
                  | translate
                    : { rsdLimit: rsdLimitValue, msdLimit: msdLimitValue }
              }}
            </small>
          </ng-template>
          <ng-template #daySupply>
            <small>
              <b>
                {{
                  'drugNameSearch.notes.' + noteVal + '.long_form' | translate
                }}:</b
              >
              {{
                'drugNameSearch.notes.SD.description_XY'
                  | translate
                    : {
                        rsdSupply: otherInfo.retailSpecialtyDaySupply,
                        msdSupply: otherInfo.mailSpecialtyDaySupply
                      }
              }}
            </small>
          </ng-template>
          <ng-template #nyMessage>
            <div [ngClass]="{ 'col-11': screen.isLargerOrEqual('md') }">
              <small
                ><b>
                  {{
                    'drugNameSearch.notes.' + noteVal + '.long_form'
                      | translate
                  }}:</b
                >
                <span
                  [innerHTML]="
                    'drugNameSearch.notes.' + noteVal + '.descriptionNY'
                      | translate
                  "
                >
                </span
              ></small>
            </div>
          </ng-template>
        </div>
      </div>
    </div>
  </ng-container>
</div>
